module.exports = __webpack_public_path__ + "img/82.816fe9c3.webp";